import { Injectable } from '@angular/core';
import { ApiHelperService } from './api-helper.service';
import { ConfigService } from './config.service';
import { environment } from 'projects/foreign-admits/src/environments/environment';
declare var Razorpay: any;
@Injectable({
  providedIn: 'root',
})
export class RazorpayService {
  razorpayConfig: any;
  razorpayOptions = {
    handler: function (response) {
      let event = new CustomEvent('payment.success', {
        detail: response,
        bubbles: true,
      });
      window.dispatchEvent(event);
    },
  };
  razorpayVisaOptions = {
    handler: function (response) {
      let event = new CustomEvent('payment.visa.success', {
        detail: response,
        bubbles: true,
      });
      window.dispatchEvent(event);
    },
  };
  razorpayOnetoOneoptions = {
    handler: function (response) {
      let event = new CustomEvent('payment.oneToOne.success', {
        detail: response,
        bubbles: true,
      });
      window.dispatchEvent(event);
    },
  };
  razorpayMockVisaOptions = {
    handler: function (response) {
      let event = new CustomEvent('payment.mockVisa.success', {
        detail: response,
        bubbles: true,
      });
      window.dispatchEvent(event);
    },
  };
  constructor(
    private apiHelper: ApiHelperService,
    private config: ConfigService
  ) {
     

      this.razorpayConfig = {
        keyId: environment.razorpayKeyId,
        keySecret: environment.razorpayKeySecret
      };
  }

  openPaymentCheckout(data: any, userDetails: any, paymentFor: string) {
    let extraOptions = {
      order_id: data?.orderDetails?.id,
      amount: data?.orderDetails?.amount,
      currency: data?.orderDetails?.currency,
      key: this.razorpayConfig?.keyId,
      prefill: {
        name: userDetails?.name,
        email: userDetails?.email,
        contact: userDetails?.mobile,
      },
    };
    if (paymentFor === 'Interview') {
      Object.assign(this.razorpayOptions, extraOptions);
      let razor = new Razorpay(this.razorpayOptions);
      razor.open();

      razor.on('payment.failed', function (response) {
        // Todo - store this information in the server
        this.error = response.error.reason;
      });
    }
    if (paymentFor === 'VisaPlan') {
      Object.assign(this.razorpayVisaOptions, extraOptions);
      let razor = new Razorpay(this.razorpayVisaOptions);
      razor.open();
      razor.on('payment.failed', function (response) {
        // Todo - store this information in the server
        this.error = response.error.reason;
      });
    }
    if (paymentFor === 'oneToOne') {
      Object.assign(this.razorpayOnetoOneoptions, extraOptions);
      let razor = new Razorpay(this.razorpayOnetoOneoptions);
      razor.open();
      razor.on('payment.failed', function (response) {
        // Todo - store this information in the server
        this.error = response.error.reason;
      });
    }
    if (paymentFor === 'MockVisa') {
      Object.assign(this.razorpayMockVisaOptions, extraOptions);
      let razor = new Razorpay(this.razorpayMockVisaOptions);
      razor.open();
      razor.on('payment.failed', function (response) {
        // Todo - store this information in the server
        this.error = response.error.reason;
      });
    }
  }
  createOrder(dataModel: any, orderDetails: any) {
    if (orderDetails) {
      return this.apiHelper.postData(dataModel, orderDetails);
    }
  }

  updateOrder(dataModel: any, orderDetails: any) {
    if (orderDetails) {
      return this.apiHelper.postData(dataModel, orderDetails);
    }
  }
}
